import { Pipe, PipeTransform } from '@angular/core';
import { IUnderlyingInstrument } from '@spa/api';

@Pipe({
  name: 'productUnderlyings'
})
export class ProductUnderlyingsPipe implements PipeTransform {
  transform(underlyings: IUnderlyingInstrument[]): string {
    return underlyings.map(item => item.name || item.symbol).join(', ');
  }
}
